module.exports = __webpack_public_path__ + "img/Vanuatu.19c6607f.svg";